import { HttpParameterCodec, HttpParams } from "@angular/common/http";

export class Helpers {
    public static createIterableArray = (length: number) => Array(length);

    public static capitalize = (value: string) => value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase();

    public static prepareGetParamsFromArray(filters: Array<{ name; value }>, useCustomEncoder: boolean = false): HttpParams {
        let httpParams = useCustomEncoder ? new HttpParams({ encoder: new CustomHttpParamEncoder() }) : new HttpParams();
        filters.forEach((param) =>
            !Array.isArray(param.value)
                ? (httpParams = httpParams.append(param.name, param.value))
                : param.value.forEach((item) => (httpParams = httpParams.append(param.name, item))),
        );

        return httpParams;
    }

    public static prepareGetParamsFromObject(filters: object, useCustomEncoder: boolean = false): HttpParams {
        let httpParams = useCustomEncoder ? new HttpParams({ encoder: new CustomHttpParamEncoder() }) : new HttpParams();
        Object.keys(filters).forEach((key) =>
            !Array.isArray(filters[key])
                ? (httpParams = httpParams.append(key, String(filters[key])))
                : (filters[key] as unknown[]).forEach((item) => (httpParams = httpParams.append(`${key}[]`, String(item)))),
        );

        return httpParams;
    }

    public static snakeToCamel = (str) => str.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());

    public static camelToSnake = (str) =>
        str
            .split(/(?=[A-Z])/)
            .join("_")
            .toLowerCase();
}

export class CustomHttpParamEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
